import React from "react";
import styles from "../TextWithBg/TextWithBg.module.css";
import Animations from "../Animations/animations";

const TextWithBg = ({ content }) => {
  return (
    <section className={styles.conclusionSec}>
      <div className={styles.container}>
       
      <Animations animationType="fadeInUp" threshold={0.2}>
            <h2>{content.heading}</h2>
            <p
              dangerouslySetInnerHTML={{
                __html: content.description
                  ? content.description.replace(/\n/g, "<br />") // Replace newlines with <br />
                  : content.description, // If subText is undefined or null, display an empty string
              }}
            />
            {content.highlightedText && 
            <p className={styles.highlightedText}> {content.highlightedText} </p>
            }
      </Animations>
      </div>
    </section>
  );
};

export default TextWithBg;
